import React from "react";
import Logo from "../components/Logo";

export default function Login() {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F5F4F0] via-[#F5F4F0] to-[#EFEDE4] flex items-center justify-center px-4 relative overflow-hidden" data-testid="login-page">
      {/* Subtle ambient blobs */}
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-[#1F2A47]/5 rounded-full blur-3xl" />
      <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-[#BC4727]/5 rounded-full blur-3xl" />

      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl shadow-slate-900/5 relative overflow-hidden border border-slate-100">
        <div className="p-7 pb-6 bg-gradient-to-br from-[#1F2A47] to-[#15203A] text-white flex items-center gap-4">
          <div className="w-14 h-14 bg-white/10 backdrop-blur rounded-xl p-1.5 flex items-center justify-center">
            <Logo size={48} className="rounded-md" />
          </div>
          <div>
            <div className="brand-tag text-[1.75rem] leading-none">AcreLatch</div>
            <div className="text-[11px] tracking-[0.14em] text-slate-300 mt-1.5 font-medium">
              Farm Ops · Tax Log
            </div>
          </div>
        </div>

        <div className="p-7 space-y-6">
          <div className="space-y-2">
            <h1 className="font-display text-2xl font-bold text-[#1F2A47]">Welcome back</h1>
            <p className="text-sm text-slate-600 leading-relaxed">
              Sign in with Google to continue. The first person to sign in claims the farm as Owner — after that, only invited teammates can join.
            </p>
          </div>

          <button
            onClick={handleGoogle}
            data-testid="login-google-btn"
            className="w-full bg-[#1F2A47] text-white py-3 px-6 font-semibold text-sm hover:bg-[#15203A] transition-all flex items-center justify-center gap-3 rounded-xl shadow-lg shadow-[#1F2A47]/20 hover:shadow-xl hover:shadow-[#1F2A47]/30 hover:-translate-y-0.5"
            data-raw="true"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            Sign in with Google
          </button>

          <div className="pt-4 border-t border-slate-100">
            <div className="text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-500 mb-3">
              Roles at a glance
            </div>
            <ul className="space-y-2 text-sm text-slate-600">
              <li className="flex gap-2">
                <span className="w-1.5 h-1.5 bg-[#1F2A47] rounded-full mt-2 flex-shrink-0" />
                <span><span className="font-semibold text-[#1F2A47]">Owner</span> — full access, invites teammates</span>
              </li>
              <li className="flex gap-2">
                <span className="w-1.5 h-1.5 bg-[#1F2A47] rounded-full mt-2 flex-shrink-0" />
                <span><span className="font-semibold text-[#1F2A47]">Farm Manager</span> — day-to-day ops, own expenses only</span>
              </li>
              <li className="flex gap-2">
                <span className="w-1.5 h-1.5 bg-[#1F2A47] rounded-full mt-2 flex-shrink-0" />
                <span><span className="font-semibold text-[#1F2A47]">Farm Hand</span> — scoped (livestock / equipment / fields)</span>
              </li>
              <li className="flex gap-2">
                <span className="w-1.5 h-1.5 bg-[#1F2A47] rounded-full mt-2 flex-shrink-0" />
                <span><span className="font-semibold text-[#1F2A47]">Read-Only</span> — accountant / CPA view</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
